import React, { Component } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { AppCard, PageLayout } from "../../components/ui";
import { createTabHeaderTemplate } from "../../components/ui/tabHeaderTemplate";
import { Receipt } from "lucide-react";
import BoricaPayments from "./BoricaPayments";
import Transactions from "./Transactions";
import StatusChangelog from "./StatusChangelog";
import { fastPayFeatureFlagService } from "../../services/api/featureFlags/FastPayFeatureFlagService";

const EXTENDED_REPORTING_FLAG = "merchant.fastpaylite.transactions.extended_reporting";

interface FastPayTransactionsState {
    activeIndex: number;
    extendedReportingEnabled: boolean;
    flagLoaded: boolean;
}

export default class FastPayTransactions extends Component<Record<string, never>, FastPayTransactionsState> {
    constructor(props: Record<string, never>) {
        super(props);
        this.state = { activeIndex: 0, extendedReportingEnabled: false, flagLoaded: false };
    }

    async componentDidMount() {
        const enabled = await fastPayFeatureFlagService.isEnabled(EXTENDED_REPORTING_FLAG);
        this.setState({ extendedReportingEnabled: enabled, flagLoaded: true });
    }

    render() {
        const { extendedReportingEnabled, flagLoaded } = this.state;

        return (
            <PageLayout heading="FastPay Transactions" icon={Receipt}>
                <AppCard>
                    <AppCard.Body className="!p-0">
                        {flagLoaded && (
                            <TabView
                                activeIndex={this.state.activeIndex}
                                onTabChange={(e) => this.setState({ activeIndex: e.index })}
                            >
                                <TabPanel header="FastPay Transactions" headerTemplate={createTabHeaderTemplate(this.state.activeIndex)}>
                                    <Transactions extendedReportingEnabled={extendedReportingEnabled} />
                                </TabPanel>
                                <TabPanel header="Borica Payments" headerTemplate={createTabHeaderTemplate(this.state.activeIndex)}>
                                    <BoricaPayments extendedReportingEnabled={extendedReportingEnabled} />
                                </TabPanel>
                                <TabPanel header="Changelog" headerTemplate={createTabHeaderTemplate(this.state.activeIndex)}>
                                    <StatusChangelog />
                                </TabPanel>
                            </TabView>
                        )}
                    </AppCard.Body>
                </AppCard>
            </PageLayout>
        );
    }
}
